// extracted by mini-css-extract-plugin
module.exports = {"kontaktOssKanal":"KontaktOssKanalLayout_kontaktOssKanal__uglqT","content":"KontaktOssKanalLayout_content__LTUQ4"};